<nav class="navbar navbar-toggleable-md navbar-light bg-primary">
  <div class="navbar-brand ml-auto" href="#">.</div>
</nav>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/layout/components/layout-account-header/layout-account-header.component.html